module.exports = __webpack_public_path__ + "img/CloseImg.2f886173.svg";